import React__default from 'react';

var ArtworkContactProfile = function ArtworkContactProfile(props) {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    className: props === null || props === void 0 ? void 0 : props.className
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#E5E7E9",
    d: "M0 0h160v160H0z"
  }), /*#__PURE__*/React__default.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#F2F3F4",
    d: "M0 0h160v160H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#F2F3F4",
    d: "M0 0h160v160H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M81.23 76.615c18.382 0 33.232-14.932 33.232-33.23 0-18.298-14.85-33.231-33.231-33.231S48 24.982 48 43.384c0 18.404 14.85 33.231 33.23 33.231ZM80 82.462c-43.505 0-78.77 34.713-78.77 77.538H158.77c0-42.825-35.264-77.538-78.769-77.538Z",
    fill: "#E5E7E9"
  })), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#FCFDFD",
    d: "M0 0h160v160H0z"
  }))));
};
var ArtworkContactProfile$1 = ArtworkContactProfile;

export { ArtworkContactProfile, ArtworkContactProfile$1 as default };
//# sourceMappingURL=artwork-contact-profile.esm.js.map
